const euro = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
const dateTime = new Intl.DateTimeFormat("fr-FR", { dateStyle: "medium", timeStyle: "short" });
const dateOnly = new Intl.DateTimeFormat("fr-FR", { dateStyle: "medium" });

export function formatCents(cents: number | null | undefined) {
  if (cents === null || cents === undefined) return "—";
  return euro.format(cents / 100);
}

export function formatPercent(ratio: number | null | undefined, digits = 1) {
  if (ratio === null || ratio === undefined) return "—";
  return `${(ratio * 100).toFixed(digits).replace(".", ",")} %`;
}

export function formatDate(value: string | null | undefined) {
  if (!value) return "—";
  return dateOnly.format(new Date(value));
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) return "—";
  return dateTime.format(new Date(value));
}

export function formatNumber(value: number | null | undefined) {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat("fr-FR").format(value);
}
